<template>
    <!-- Team start -->
  <section class="section" id="services">
          <div class="container">
              <div class="row justify-content-center mb-5">
                  <div class="col-lg-12">
                      <h4 class="text-uppercase mb-3 pb-1">커뮤니티</h4>
                      <div class="card rounded border-0 shadow overflow-hidden">
                          <ul class="nav nav-tabs" id="myTab" role="tablist">
                              <li class="nav-item" role="presentation">
                                  <button class="nav-link active" id="review-tab" data-bs-toggle="tab" data-bs-target="#review" type="button" role="tab" aria-controls="review" aria-selected="true">이용후기</button>
                              </li>
                              <li class="nav-item" role="presentation">
                                  <button class="nav-link " id="notice-tab" data-bs-toggle="tab" data-bs-target="#notice" type="button" role="tab" aria-controls="notice" aria-selected="false">공지사항</button>
                              </li>

                              <li class="nav-item" role="presentation">
                                  <button class="nav-link" id="qna-tab" data-bs-toggle="tab" data-bs-target="#qna" type="button" role="tab" aria-controls="qna" aria-selected="false">질문게시판</button>
                              </li>
                              <!-- <li class="nav-item" role="presentation">
                                  <button class="nav-link" id="etc-tab" data-bs-toggle="tab" data-bs-target="#etc" type="button" role="tab" aria-controls="etc" aria-selected="false">자유게시판</button>
                              </li> -->
                          </ul>
                          <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade show active px-4 py-5" id="review" role="tabpanel" aria-labelledby="review-tab">
                                  <h4 class="text-uppercase mb-3 pb-1 text-center">이용후기</h4>
                                  <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">제목</th>
                                            <th scope="col" class="text-left">작성자</th>
                                            <th scope="col" class="text-left">작성일</th>
                                            <th scope="col" class="text-left">조회</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in reviews" :key="item.boardNum" >
                                            <td><a :href="'https://cafe.naver.com/oliviewlabs/' + item.boardNum" target="_blank">{{item.boardArticle}} <span v-if="item.boardCmt > 0" class="cmt">[{{item.boardCmt}}]</span></a></td>
                                            <td>{{item.boardName}}</td>
                                            <td>{{item.boardDate}}</td>
                                            <td>{{item.boardView}}</td>
                                        </tr>
                                    </tbody>
                                  </table>
                                  <div class="d-flex flex-row-reverse mb-3">
                                    <a :href="'https://cafe.naver.com/ca-fe/cafes/30008802/menus/57/articles/write?boardType=L'" target="_blank" type="button" class="p-2 btn btn-primary btn-sm m-2">글쓰기</a> 
                                  </div>
                                  <ul>
                                    <li class="text-muted">카페 게시글이 반영되기까지 최대 24시간 소요됩니다.​</li>
                                  </ul>
                              </div>
                              <div class="tab-pane fade  px-4 py-5" id="notice" role="tabpanel" aria-labelledby="notice-tab">
                                  <h4 class="text-uppercase mb-3 pb-1 text-center">공지사항</h4>
                                  <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">제목</th>
                                            <th scope="col" class="text-left">작성자</th>
                                            <th scope="col" class="text-left">작성일</th>
                                            <th scope="col" class="text-left">조회</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in notices" :key="item.boardNum" >
                                            <td><a :href="'https://cafe.naver.com/oliviewlabs/' + item.boardNum" target="_blank">{{item.boardArticle}} <span v-if="item.boardCmt > 0" class="cmt">[{{item.boardCmt}}]</span></a></td>
                                            <td>{{item.boardName}}</td>
                                            <td>{{item.boardDate}}</td>
                                            <td>{{item.boardView}}</td>
                                        </tr>
                                    </tbody>
                                  </table>
                              </div>
                              
                              <div class="tab-pane fade px-4 py-5" id="qna" role="tabpanel" aria-labelledby="qna-tab">
                                  <h4 class="text-uppercase mb-3 pb-1 text-center">질문게시판</h4>
                                  <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">제목</th>
                                            <th scope="col" class="text-left">작성자</th>
                                            <th scope="col" class="text-left">작성일</th>
                                            <th scope="col" class="text-left">조회</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in qnas" :key="item.boardNum" >
                                            <td><a :href="'https://cafe.naver.com/oliviewlabs/' + item.boardNum" target="_blank">{{item.boardArticle}} <span v-if="item.boardCmt > 0" class="cmt">[{{item.boardCmt}}]</span></a></td>
                                            <td>{{item.boardName}}</td>
                                            <td>{{item.boardDate}}</td>
                                            <td>{{item.boardView}}</td>
                                        </tr>
                                    </tbody>
                                  </table>
                                  <div class="d-flex flex-row-reverse mb-3">
                                    <a :href="'https://cafe.naver.com/ca-fe/cafes/30008802/menus/59/articles/write?boardType=L'" target="_blank" type="button" class="p-2 btn btn-primary btn-sm m-2">글쓰기</a> 
                                  </div>
                                  <ul>
                                    <li class="text-muted">카페 게시글이 반영되기까지 최대 24시간 소요됩니다.​</li>
                                  </ul>
                              </div>
                              <!-- <div class="tab-pane fade px-4 py-5" id="etc" role="tabpanel" aria-labelledby="etc-tab">
                                  <h4 class="text-uppercase mb-3 pb-1 ">자유게시판</h4>
                              </div> -->
                          </div>
                          
                      </div>
                  </div>
  
                  <div>
                      <!-- <center style="margin-top:20px;"><iframe width="800" height="600" src="https://www.youtube.com/embed/chKcte7A1P8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></center> -->
                  </div>
              </div>
  
          </div>
          <!-- end container -->
  
      </section>
  
  </template>
  
<script>
import axios from 'axios';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
import Swal from '../../../js/sweetalert2.min.js';
  
  
  export default {
      data(){
          return {
              notices: [],
              reviews: [],
              qnas: [],
              local : ""
          }
      },
      beforeMount(){
          axios.get(this.local + "/board/article")
          .then(response => {  
                Swal.close();

                if(response.status == 200){
                    var articles = response.data;                   
                    for (var i = 0; i < articles.length; i++) {
                        let article = articles[i]
                        let menu = article.boardMenu
                        article.boardDate = article.boardDate.substring(0,10).replaceAll("-",".")
                        switch(menu) {
                            case 59:
                                this.qnas.push(article)
                                break;
                            case 57:
                            case 66:
                                this.reviews.push(article)
                                break;
                            case 27:
                                this.notices.push(article)
                                break;
                        }
                    }
                }
              
          }).catch(error => {
                this.invalidSession(error)
          });
      },
      methods: {
        invalidSession: function(error){
            Swal.close();
            if(error && error.response && error.response.status && error.response.status == 401){
                swal('세션이 만료되었습니다. 다시 로그인 해주세요.').then(() => {
                    this.$router.push('/signin')
                });
            } else {
                swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.", {icon: "info"})
            }
        },
        dateformat: function(current_datetime){
            var month = current_datetime.getMonth() + 1
            if(month < 10){
                month = "0" + month;
            }

            var day = current_datetime.getDate()
            if(day < 10){
                day = "0" + day;
            }

            let formatted_date = current_datetime.getFullYear() + ""+ month + "" + day;
            return formatted_date;
        }
      }
  }
  </script>
  <style>
  .cmt{
    font-weight: bold;
    color: #ff2f3b;
  }

  .text-left{
    text-align: left;
  }


  .pc4-table{
      display:grid;
      grid-gap: 3px;
  }
  
  .pc4-container{
      display:grid;
      grid-template-columns: 130px 1fr 10px 1fr 10px 110px 10px 110px 10px;
      grid-gap: 3px;
  }
  .pf{
      width:20px;
      height:20px;
  }
  .pc4-pass{
      background-color: #e2efde;
      text-overflow:ellipsis;
      white-space:nowrap;
      overflow:hidden;
  }
  .pc4-fail{
      background-color: #ec7b7b;
      text-overflow:ellipsis;
      white-space:nowrap;
      overflow:hidden;
  }
  .pc4-empty{
      background-color: #eeeeee;
  }
  .pc4-pc4{
      background-color: #eff1fc;
  }
  .pc4-title{
      font-weight: bold;
      
  }
  .step{
      width:100%; 
      border: 1px solid #000000; 
      image-rendering: -webkit-optimize-contrast; 
      transform: translateZ(0); 
      backface-visibility: hidden;
      margin-bottom: 0.5rem!important;
  }
  
  
  .nav-item .nav-link.active{
      padding: 0.5rem 1rem;
  }
  
  
  .nav-item .nav-link{
      display: block;
      padding: 0.5rem 1rem 0.44rem;
      color: #0d6efd;
      text-decoration: none;
      background-color: #fff;
  }
  
  .divta1{
      height: 200px;
      width: 150px;
  }
  
  .divta2{
      height: 200px;
  }
  .divta3{
      height: 200px;
      width: 140px;
  }
  </style>


// WEBPACK FOOTER //
// src/components/main/Board.vue